import { Controller } from "@hotwired/stimulus"

// O assistente de publicação (admin/posts/publications): um form só, uma etapa visível por vez.
// Publicar e agendar ficam desabilitados até todas as etapas terem sido vistas — o assistente
// existe para que ninguém publique sem olhar resumo, classificação e SEO. A etapa atual vai no hash
// (#etapa-2) para sobreviver a um reload. Com `free` (post já no ar) a navegação é livre.
export default class extends Controller {
  static targets = ["step", "tab", "prev", "next", "publish"]
  static values = { free: Boolean }

  connect() {
    this.visited = new Set()

    // Voltou do servidor com erro (422): tudo já foi visto, e a etapa que abre é a do primeiro erro.
    const withError = this.stepTargets.findIndex((step) => step.querySelector(".is-invalid, .invalid-feedback"))
    if (withError >= 0 || this.freeValue) this.stepTargets.forEach((_, index) => this.visited.add(index))

    this.show(withError >= 0 ? withError : this.#indexFromHash())
  }

  go({ params: { step } }) {
    this.show(Number(step))
  }

  next() {
    this.show(this.index + 1)
  }

  prev() {
    this.show(this.index - 1)
  }

  show(index) {
    const last = this.stepTargets.length - 1
    this.index = Math.min(Math.max(index, 0), last)
    this.visited.add(this.index)

    this.stepTargets.forEach((step, i) => { step.hidden = i !== this.index })
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("is-active", i === this.index)
      tab.classList.toggle("is-visited", this.visited.has(i))
      if (i === this.index) tab.setAttribute("aria-current", "step")
      else tab.removeAttribute("aria-current")
    })

    this.prevTarget.hidden = this.index === 0
    this.nextTarget.hidden = this.index === last

    const ready = this.visited.size === this.stepTargets.length
    this.publishTargets.forEach((button) => {
      button.hidden = this.index !== last
      button.disabled = !ready
    })

    history.replaceState(history.state, "", `#etapa-${this.index + 1}`)
    this.dispatch("change", { detail: { index: this.index } })
  }

  #indexFromHash() {
    const match = window.location.hash.match(/^#etapa-(\d+)$/)
    return match ? Number(match[1]) - 1 : 0
  }
}
